const SalesTaxPageRow = ({
  title,
  value,
  renderValue,
}: {
  title: string;
  value?: string;
  renderValue?: () => React.ReactNode;
}) => {
  return (
    <div className="flex items-center justify-between">
      <p className="txt-small-medium text-text-quaternary">
        {title}
        <span className="text-bg-fg-secondary">*</span>
      </p>
      <div className="w-96 overflow-hidden">
        {renderValue ? (
          renderValue()
        ) : (
          <p className="txt-medium-medium text-text-primary">{value}</p>
        )}
      </div>
    </div>
  );
};

export default SalesTaxPageRow;
